var React = require('react');

function IconABtest (props) {
    return React.createElement("svg",props,[React.createElement("path",{"id":"패스_2152","data-name":"패스 2152","className":"cls-1","d":"M19.618 4h-1.932L13.63 14.8h1.87l.972-2.76h4.358l.96 2.76h1.884zm-2.58 6.468L18.61 6h.1l1.572 4.464z","transform":"translate(-4.552 .2)","key":0}),React.createElement("path",{"id":"패스_2158","data-name":"패스 2158","className":"cls-1","d":"M4.4 6.8H2v16.8A2.407 2.407 0 0 0 4.4 26h16.8v-2.4H4.4zM23.6 2H9.2a2.407 2.407 0 0 0-2.4 2.4v14.4a2.407 2.407 0 0 0 2.4 2.4h14.4a2.407 2.407 0 0 0 2.4-2.4V4.4A2.407 2.407 0 0 0 23.6 2zm0 16.8H9.2V4.4h14.4z","transform":"translate(-2 -2)","key":1})]);
}

IconABtest.defaultProps = {"id":"icon_a_btest","data-name":"icon_a/btest","width":"24","height":"24"};

module.exports = IconABtest;

IconABtest.default = IconABtest;
